export const CASE_STATUS_DRAFTED = "DRAFT";
export const CASE_STATUS_CREATED = "CREATED";
export const CASE_STATUS_SUBMITTED = "SUBMITED";
export const CASE_STATUS_COMPLETED = "COMPLETED";
export const CASE_STATUS_ARCHIVED = "ARCHIVED";

export const CASE_REVIEW_STATUS_ASSIGNED = "ASSIGNED";
export const CASE_REVIEW_STATUS_SUMITTED = "SUBMITED";
export const CASE_REVIEW_STATUS_ACCEPTED = "ACCEPTED";
export const CASE_REVIEW_STATUS_REJECTED = "REJECTED";
export const CASE_REVIEW_STATUS_RESOLVED = "RESOLVED";